<template>
  <v-dialog :value="value" :width="1440" persistent scrollable>
    <v-card>
      <v-card-title class="py-0" :style="{ justifyContent: 'space-between' }">
        <div class="h4 font-weight-bold">Ticket ID: {{ ticketId }}</div>
        <v-btn icon left @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <iframe
        :src="url"
        allowfullscreen="true"
        sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation allow-downloads"
        style="
          display: block;
          height: calc(90dvh - 48px);
          overflow: auto;
          width: 100%;
          border: none;
        "
      ></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    ticketId: {
      type: Number,
      default: undefined
    },
    url: {
      type: String,
      default: ''
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data.event_id === 'open_external_link') {
        if (window.innerWidth < 960) {
          window.open(event.data.url, '_blank')
        } else {
          if (
            event.data.url.includes('https://enterprise-drive.zwiz.app') ||
            event.data.url.includes('https://enterprise-s3.zwiz.app')
          ) {
            this.downloadFile(event.data.url, `file_${Date.now()}`)
          } else {
            window.open(event.data.url, '_blank')
          }
        }
      } else if (event.data.event_id === 'copy_to_clipboard') {
        if (event.data.value) navigator.clipboard.writeText(event.data.value)
      } else if (event.data.event_id === 'open_link') {
        window.open(event.data.url, '_self')
      }
    },
    downloadFile(url, filename) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = filename
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(blobUrl)
        })
        .catch((error) => console.error('Download failed:', error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/ChatDialog.vue